<!-- 工作台 -->
<template>
  <div v-loading="loading">
    <el-form
      :model="submitData"
      ref="formMsg"
      label-width="80px"
      style="width: 100%; padding-right: 30px"
      :rules="rules"
    >
      <div class="form-bottom">
        <el-form-item label="型号">
          <el-input
            style="width: 100%"
            v-model.trim="submitData.Model"
            disabled
          >
          </el-input>
        </el-form-item>
        <el-form-item label="编号">
          <el-input disabled v-model.trim="submitData.DeviceNo"> </el-input>
        </el-form-item>
        <el-form-item label="名称" prop="Name">
          <el-input style="width: 100%" v-model.trim="submitData.Name">
          </el-input>
        </el-form-item>
        <el-form-item label="宽度" prop="BillWidth">
          <el-input-number  style="width: 50%" v-model.trim="submitData.BillWidth">
          </el-input-number>
        </el-form-item>
        <el-form-item label="备注">
          <el-input style="width: 100%" v-model.trim="submitData.Remark">
          </el-input>
        </el-form-item>
      </div>
    </el-form>
    <div class="dialog-footer">
      <el-button class="btn-primary" @click="submitForm">提交</el-button>
      <el-button @click="cancel()">取消</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  props: ["PrinterData"],
  components: {},
  data() {
    let userMsg = this.$util.getLocalStorage("userMsg");
    return {
      loading: false,
      userMsg: userMsg,
      canRequest: true,
      submitData: {
        Id: "",
        DeviceNo: "",
        BillWidth: "",
        Name: "",
        EntpId: userMsg.EntpId,
        Model: "",
        Remark: "",
        UserId: userMsg.EmployeeId,
      },
      rules: {
        Name: [{ required: true, message: "该项必填", trigger: "blur" }],
        BillWidth: [{ required: true, message: "该项必填", trigger: "blur" }],
      },
    };
  },
  mounted() {
    this.submitData = this.PrinterData;
  },
  methods: {
    submitForm() {
      let that = this;
      that.$refs.formMsg.validate((valid) => {
        if (valid) {
          if (!that.canRequest) {
            return;
          }
          that.canRequest = false;
          that.loading = true;
          that.$util
            .axiosPost({
              url: "/api/EntpInfoManagement/EditPrinterInfoes",
              data: that.submitData,
              hideLoading: true,
            })
            .then(() => {
              that.$util.successMsg("提交成功");
              that.$emit("closeDialog", true);
            })
            .catch(() => {
              that.canRequest = true;
              that.loading = false;
            });
        }
      });
    },
    cancel() {
      this.$emit("closeDialog");
    },
  },
};
</script>
<style lang="less" scoped>
.form-main {
  display: flex;
  > div {
    width: 50%;
  }
}
.dialog-footer {
  text-align: right;
}
</style>
